/**
 * Shared 6-digit TOTP code input — single primitive for every 2FA surface
 * (enrollment in TwoFactorSetup, step-up in the retry-BC dialog). Sanitizes
 * to digits only and truncates at 6; paste/a11y improvements land here once
 * for all consumers.
 */
export function TotpCodeInput({
  value,
  onChange,
  id,
  autoFocus,
}: {
  value: string;
  onChange: (code: string) => void;
  id?: string;
  autoFocus?: boolean;
}) {
  return (
    <input
      id={id}
      inputMode="numeric"
      autoComplete="one-time-code"
      maxLength={6}
      value={value}
      autoFocus={autoFocus}
      onChange={(e) => onChange(e.target.value.replace(/\D/g, "").slice(0, 6))}
      placeholder="000000"
      className="w-full rounded-md border px-3 py-2 font-mono tracking-widest"
    />
  );
}
